var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLabel = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3 3.25A1.75 1.75 0 0 0 1.25 5v6c0 .966.784 1.75 1.75 1.75h7.5a2.75 2.75 0 0 0 2.2-1.1l1.725-2.3c.6-.8.6-1.9 0-2.7L12.7 4.35a2.75 2.75 0 0 0-2.2-1.1zM2.75 5A.25.25 0 0 1 3 4.75h7.5c.393 0 .764.185 1 .5l1.725 2.3c.2.267.2.633 0 .9l-1.725 2.3a1.25 1.25 0 0 1-1 .5H3a.25.25 0 0 1-.25-.25z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLabel);
export default ForwardRef;